export const OTP_HEADER_NAME = 'ep-2fa-code'
export const TWO_FACTOR_AUTH_REQUIRED_STATUS = 439
export const TWO_FACTOR_AUTH_EXPIRED_STATUS = 441
export const TWO_FACTOR_AUTH_INCORRECT_STATUS = 440